// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const NetworkDevicesIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="NetworkDevicesIcon" ref={forwardedRef} {...props}>
      <path d="M4 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.25v1.114a2.5 2.5 0 0 0-1.635 1.636H3.001v1.5h4.614a2.501 2.501 0 0 0 4.771 0h4.615v-1.5h-4.615a2.5 2.5 0 0 0-1.635-1.636V13H16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm.5 1.5h4.75V6h1.5V4.5h1.5V6h1.5V4.5h1.75v2.75h-11zm0 7V8.75h11v2.75zm6.162 4.25A1 1 0 0 1 11 16.5a.997.997 0 0 1-1 1 1 1 0 1 1 .662-1.75" />
    </SvgIcon>
  );
});

/**
 * Use to show devices connected to a network
 * @public
 */
export const NetworkDevicesIcon = /* @__PURE__ */ Object.assign(
  NetworkDevicesIconComponent,
  { displayName: 'NetworkDevicesIcon' },
);
